import FanRallyLogo from "components/FanRallyLogo";
import TenantLogo from "components/TenantLogo";
import React from "react";
import { Platform } from "react-native";

interface Options {
  isDarkBackground?: boolean;
}

export const resolveLogo = (options?: Options | undefined) => {
  const isDarkBackground = options?.isDarkBackground ?? true;

  if (Platform.OS === "web") {
    return <TenantLogo isDarkBackground={isDarkBackground} />;
  } else {
    return <FanRallyLogo width={70} height={70} />;
  }
};
